import { generateGUID } from "@/utils/guid";
import { FormSection } from "../types";

export const duplicateFormSection = (section:FormSection):FormSection => {
	const copy = JSON.parse(JSON.stringify(section)) as FormSection;
	copy.id = generateGUID();
	copy.items.forEach(item => item.id = generateGUID());
	return copy;
};